import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';

import { MarketmanagerSharedModule } from '../../shared';
import {
    EnergyflatService,
    EnergyflatPopupService,
    EnergyflatComponent,
    EnergyflatDetailComponent,
    EnergyflatDialogComponent,
    EnergyflatPopupComponent,
    EnergyflatDeletePopupComponent,
    EnergyflatDeleteDialogComponent,
    energyflatRoute,
    energyflatPopupRoute,
    EnergyflatResolvePagingParams,
} from './';

const ENTITY_STATES = [
    ...energyflatRoute,
    ...energyflatPopupRoute,
];

@NgModule({
    imports: [
        MarketmanagerSharedModule,
        RouterModule.forRoot(ENTITY_STATES, { useHash: true })
    ],
    declarations: [
        EnergyflatComponent,
        EnergyflatDetailComponent,
        EnergyflatDialogComponent,
        EnergyflatDeleteDialogComponent,
        EnergyflatPopupComponent,
        EnergyflatDeletePopupComponent,
    ],
    entryComponents: [
        EnergyflatComponent,
        EnergyflatDialogComponent,
        EnergyflatPopupComponent,
        EnergyflatDeleteDialogComponent,
        EnergyflatDeletePopupComponent,
    ],
    providers: [
        EnergyflatService,
        EnergyflatPopupService,
        EnergyflatResolvePagingParams,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class MarketmanagerEnergyflatModule {}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/energyflat/energyflat.module.ts